import { useMemo, useState } from "react";
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";
import Spinner from 'react-bootstrap/Spinner';

export function KPPlanetLinks ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Planet Links Page');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/planetlink/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
          <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Planet Links</h5></caption>
          <thead>
            <tr class="p-0">
              <th class="p-0 kptable-td">Planet</th> 
              <th class="p-0 kptable-td">Star Lord</th> 
              <th class="p-0 kptable-td">Sub Lord</th> 
            </tr>
          </thead>
          <tbody>
          {
            chartData.map((planet) => (
                <tr class="p-0" onClick={handleClickColor}>
                    <th class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[1]}</th>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[2]}</td>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[3]}</td>
                </tr>
            ))
          }
            </tbody>  
          </table>
          )
        }
        </>
      );
  }